import type { ReactNode } from 'react';

/**
 * El título de una pantalla y sus acciones, en una sola fila que se apila en pantalla angosta.
 *
 * Las acciones van siempre a la derecha y en un solo grupo, para que la botonera sea la misma en
 * todas las pantallas.
 */
export function BarraDePagina({
  titulo,
  children,
}: {
  titulo: string;
  /** Botones, filtros y buscadores de la pantalla. Se alinean a la derecha, todos juntos. */
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <h1 className="text-titulo font-extrabold">{titulo}</h1>
      {children && <div className="flex flex-wrap items-end gap-2">{children}</div>}
    </div>
  );
}
